<i18n>
{
  "en": {
    "delete": "Delete"
  },
  "zh-tw": {
    "delete": "刪除"
  }
}
</i18n>

<template>
  <f7-actions style="max-height: 60%;">
    <f7-actions-group>
      <f7-actions-label>{{ $t(`delete`) }}: {{ currentMenu.items[itemIdPathParam].title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button
        v-for="(itemObj, i) in selectedItemObjs"
        :key="`amount-adjustment-action-${i}`"
        style="overflow-x: auto;"
        @click="removeItem({ itemBucket: 'cart', id: itemObj.id, instanceId: itemObj.instanceId })">
        <span style="">{{ i + 1 }}. {{ itemDetails(itemObj) }}</span>
      </f7-actions-button>
    </f7-actions-group>

    <f7-actions-group>
      <f7-actions-button color="red" bold>Cancel</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'RadioActionSheet',
  dependencies: [
    'platformUtils',
    'CartElementBuilder'
  ],
  props: {
    storeIdPathParam: String,
    itemIdPathParam: String
  },
  computed: {
    ...mapState('itemModule', ['cart']),
    ...mapGetters(['currentMenu']),
    selectedItemObjs () { // TODO simplify this
      return Object.keys(this.cart).length !== 0
        ? Object.keys(this.cart[this.itemIdPathParam] || {}).map(k => (this.cart[this.itemIdPathParam] || {})[k])
        : []
    }
  },
  methods: {
    ...mapActions('itemModule', [
      'removeItem'
    ]),
    itemDetails (itemObj) {
      const item = this.CartElementBuilder.buildItem(itemObj, this.currentMenu)
      return item.questions
        ? item.allLevelQuestions.filter(q =>
          q.alwaysDisplay || !q.isValueDefault
        ).map(q => q.valueString).join(', ')
        : []
    }
  }
}
</script>
